import axios from 'axios'
import config from '@/config/local'

const api = axios.create()

api.interceptors.response.use(null, (error) => {
	if (!error.response || (error.response.status !== 401 && error.response.status !== 426)) {
		return Promise.resolve({
			data: {
				success: false,
				errors: [
					{
						message: `Error processing request to '${error.config.url}', status: ${error.response ? error.response.status : 'unknown'}`,
						code: 0
					}
				]
			}
		})
	}

	const returnUrl = encodeURIComponent(window.location.href)
	location.href = `${config.apiHost}/auth/login?return_url=${returnUrl}`

	return Promise.reject(error)
})

export default api
